(() => {
  const ready = () => {
    // PDP-only enhancement. Homepage content is controlled entirely by Theme Editor settings.
    const afterpay = document.getElementById('afterpay_instalments');
    if (afterpay) {
      const row = afterpay.closest('p');
      if (row) row.remove();
    }

    if (document.body.classList.contains('template-product')) {
      const widget = document.getElementById('stamped-main-widget');
      if (widget && !widget.closest('.mg-pdp-reviews-current, #MGIntegratedReviews')) {
        const shell = document.createElement('section');
        shell.className = 'mg-pdp-reviews-current';
        shell.setAttribute('aria-label', 'Customer reviews');
        const head = document.createElement('header');
        head.className = 'mg-pdp-reviews-current__head';
        head.innerHTML = '<p>Verified customer feedback</p><h2>Trusted by golfers. Loved as gifts.</h2><span>Read genuine feedback from customers who chose Mr. Golf for personalised gifts and golf essentials.</span>';
        widget.parentNode.insertBefore(shell, widget);
        shell.appendChild(head);
        shell.appendChild(widget);
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
})();

